import React from "react";
import NotFoundPage from "@error-pages/NotFoundPage.tsx";

interface State {
    hasRouteError: boolean;
    error?: Error;
}

interface Props {
    children: React.ReactNode;
}

class RouteErrorBoundary extends React.Component<Props, State> {
    static getDerivedStateFromError(error: Error): State {
        if (error.message.includes("Unknown or disallowed route") ||
            error.message.includes("Missing parameter") ||
            error.message.includes("Router not initialised")) {
            return { hasRouteError: true, error };
        }

        throw error;
    }

    constructor(props: Props) {
        super(props);
        this.state = { hasRouteError: false };
    }

    render() {
        if (this.state.hasRouteError) {
            return <NotFoundPage />;
        }

        return this.props.children;
    }
}

export default RouteErrorBoundary;